var map = {
	"./pro-img0.jpg": "c0aR",
	"./pro-img1.jpg": "IMBh",
	"./pro-img2.jpg": "gdLJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "T0Uz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/pro\-img.*\.jpg$
// module id = T0Uz
// module chunks = 1